import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import StaffDebriefList from "./staffDebriefForms/staff-debrief-list";
import StaffMember from "./staffDebriefForms/staff-member";

const STORAGE_KEY = "staffDebriefData";

const StaffDebrief = ({ selectedTask, handleStaffDialogClose }) => {
  const user = useSelector((state) => state.auth.user);
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    staffMemberInfo: {},
    selectedStaff: null,
  });
  const [allRecords, setAllRecords] = useState([]);

  // Load saved data on mount
  useEffect(() => {
    const savedData = localStorage.getItem(STORAGE_KEY);
    if (savedData) {
      const parsed = JSON.parse(savedData);
      setFormData(parsed.formData || {});
      setCurrentStep(parsed.currentStep || 0);
    }
  }, []);

  // Save to localStorage whenever formData or currentStep changes
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ formData, currentStep }));
  }, [formData, currentStep]);

  const nextStep = () => {
    // Reset formData to empty for new entry
    setFormData({
      staffMemberInfo: [],
      selectedStaff: null,
    });
    setCurrentStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setAllRecords((prev) => [...prev, formData]);
    setCurrentStep((prev) => prev - 1);
  };

  const updateFormData = (newData) => {
    setFormData((prevState) => ({
      ...prevState,
      ...newData,
    }));
  };

  const handleSubmit = async () => {
    // Include the current formData in the final submission
    const completeRecords = [...allRecords];

    const requestBody = {
      staffMemberInfo: completeRecords,
      witnessId: user?.id,
      taskName: selectedTask?.taskName,
      status: "completed",
    };

    try {
      await axios.put(`/api/staff/staffDebrief/${selectedTask?.id}`, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Clear localStorage on successful submit
      localStorage.removeItem(STORAGE_KEY);

      handleStaffDialogClose();
    } catch (error) {
      console.error("Error updating support statement:", error);
      alert("Failed to update support statement. Please try again.");
    }
  };

  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return (
          <StaffDebriefList
            formData={allRecords}
            nextStep={nextStep}
            handleStaffDialogClose={handleStaffDialogClose}
            handleSubmit={handleSubmit}
          />
        );
      case 1:
        return (
          <StaffMember
            formData={formData?.staffMemberInfo}
            updateFormData={updateFormData}
            person={formData?.selectedStaff}
            prevStep={prevStep}
          />
        );
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};

export default StaffDebrief;
